import { createSlice } from "@reduxjs/toolkit";
const examOnlineSlice = createSlice({
    name: "examonline",
    initialState: {
        exams: {
            isFetching: false,
            error: false,
            examlists: false
        },
        createxam: {
            isFetching: false,
            error: false,
            success: false
        },
        newexams: {
            isFetching: false,
            error: false,
            examlists: null
        },
        historyexams: {
            isFetching: false,
            error: false,
            examlists: null
        },
        doexams: {
            isFetching: false,
            error: false,
            data: null
        },
        submitexam: {
            isFetching: false,
            error: false,
            success: false
        },
        exambyid: {
            isFetching: false,
            error: false,
            data: null
        }
    },
    reducers: {
        getExamByIdStart: (state) => {
            state.exambyid.isFetching = true;
        },
        getExamByIdSuccess: (state, action) => {
            state.exambyid.isFetching = false;
            state.exambyid.data = action.payload;
            state.exambyid.error = false;
        },
        getExamByIdFailed: (state) => {
            state.exambyid.isFetching = false;
            state.exambyid.error = true;
        },
        submitEmxamOnlineStart: (state) => {
            state.submitexam.isFetching = true;
        },
        submitEmxamOnlineSuccess: (state) => {
            state.submitexam.isFetching = false;
            state.submitexam.error = false;
            state.submitexam.success = true;
        },
        submitEmxamOnlineFailed: (state) => {
            state.submitexam.isFetching = false;
            state.submitexam.error = true;
            state.submitexam.success = false;
        },
        getDoExamStart: (state) => {
            state.doexams.isFetching = true;
        },
        getDoExamSuccess: (state, action) => {
            state.doexams.isFetching = false;
            state.doexams.data = action.payload;
            state.doexams.error = false;
        },
        getDoExamFailed: (state) => {
            state.doexams.isFetching = false;
            state.doexams.error = true;
        },
        getHistoryExamStart: (state) => {
            state.historyexams.isFetching = true;
        },
        getHistoryExamSuccess: (state, action) => {
            state.historyexams.isFetching = false;
            state.historyexams.examlists = action.payload;
            state.historyexams.error = false;
        },
        getHistoryExamFailed: (state) => {
            state.historyexams.isFetching = false;
            state.historyexams.error = true;
        },
        getNewExamStart: (state) => {
            state.newexams.isFetching = true;
        },
        getNewExamSuccess: (state, action) => {
            state.newexams.isFetching = false;
            state.newexams.examlists = action.payload;
            state.newexams.error = false;
        },
        getNewExamFailed: (state) => {
            state.newexams.isFetching = false;
            state.newexams.error = true;
        },
        getExamStart: (state) => {
            state.exams.isFetching = true;
        },
        getExamSuccess: (state, action) => {
            state.exams.isFetching = false;
            state.exams.examlists = action.payload;
            state.exams.error = false;
        },
        getExamFailed: (state) => {
            state.exams.isFetching = false;
            state.exams.error = true;
        },
        createEmxamOnlineStart: (state) => {
            state.createxam.isFetching = true;
        },
        createEmxamOnlineSuccess: (state) => {
            state.createxam.isFetching = false;
            state.createxam.error = false;
            state.createxam.success = true;
        },
        createEmxamOnlineFailed: (state) => {
            state.createxam.isFetching = false;
            state.createxam.error = true;
            state.createxam.success = false;
        },

    }
});
export const {
    getExamByIdStart,
    getExamByIdSuccess,
    getExamByIdFailed,
    submitEmxamOnlineStart,
    submitEmxamOnlineSuccess,
    submitEmxamOnlineFailed,
    getDoExamStart,
    getDoExamSuccess,
    getDoExamFailed,
    getHistoryExamStart,
    getHistoryExamSuccess,
    getHistoryExamFailed,
    getNewExamStart,
    getNewExamSuccess,
    getNewExamFailed,
    getExamStart,
    getExamSuccess,
    getExamFailed,
    createEmxamOnlineStart,
    createEmxamOnlineSuccess,
    createEmxamOnlineFailed
} = examOnlineSlice.actions;
export default examOnlineSlice.reducer;